<template>
<ValidationObserver ref="observer">
  <form ref="add_service_categories_form" @submit.prevent="addServiceCategories">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Service Categories
        </h4>
      </md-card-header> -->
      <br>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Category Code</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="code" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Service Category Code</label>
                <md-input v-model="service_category_code" required/>
                <validation-error :errors="apiValidationErrors.service_category_code" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Category Name</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Category Name</label>
                <md-input v-model="service_category_name" required/>
                <validation-error :errors="apiValidationErrors.service_category_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Standard Cost</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="cost" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Standard Cost</label>
                <md-input v-model="service_category_standard_cost" type="text" v-on:keypress="NumbersOnly" required/>
                <validation-error :errors="apiValidationErrors.service_category_standard_cost" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          </div>
      </md-card-content>
      <br>
      <br>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { extend , ValidationObserver} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// pesan error jiak required field tidak terpenuhi
extend('name', {
  ...required,
  message: 'Service Category Name field is required'
});
extend('code', {
  ...required,
  message: 'Service Category Code field is required'
});
extend('cost', {
  ...required,
  message: 'Service Category Standard Cost field is required'
});
export default {
  name: "add-service-categories",

  props: {
    data: Object
  },

  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({
    service_category_code: null,
    service_category_name: null,
    service_category_standard_cost: null
  }),
  
  methods: {

    // fungsi tombol direct ke list view table
    backtoList(id) {
      this.$router.replace({ name: 'List Service Categories', params: { id: id } })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    // validasi add data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addServiceCategories()
        }
      });
    },
    
    // fungsi add data
    async addServiceCategories() {
      const data = {
        type: "workshop_service_categories",
        service_category_code: this.service_category_code,
        service_category_name: this.service_category_name,
        service_category_standard_cost: this.service_category_standard_cost
      }
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_service_categories/add", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // kembali ke list service categories
        await this.$router.replace({name: 'List Service Categories'});
      } catch (e) {
        // panggil error alert
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
       // this.setApiValidation(e.response.data.errors);
      }

    }
  }
};
</script>
